﻿import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

// Import Model
import { SortCompanyModel } from "../../../../model/jubili/company-manage/company-sort";
import { UserlistModel } from "../../../../model/jubili/user-manage/get-users";
// Import Enum
import { SortType } from "../../../../enum/jubili/company-manage/sort-type";

@Component({
    selector: "bo-jub-user-table",
    templateUrl: "./user-table.component.html",
    styleUrls: ["./user-table.component.scss"]
})

export class UserTableComponent implements OnInit {

    constructor(
        public router: Router
    ) { }

    @Output() sortOutput = new EventEmitter<SortCompanyModel>();
    @Output() resetPasswordOutput = new EventEmitter<UserlistModel>();
    private _data = new BehaviorSubject<Array<UserlistModel>>(new Array<UserlistModel>());
    @Input()
    set getUserDataIndex(value) {
        this._data.next(value);
    }
    get getUserDataIndex(): Array<UserlistModel> {
        return this._data.getValue();
    }

    // using for sort user
    sortData: SortCompanyModel = new SortCompanyModel();
    sortUserSurr: boolean = false;
    sortEmail: boolean = false;
    sortFullname: boolean = false;
    sortPhone: boolean = false;
    sortCompanySurr: boolean = false;
    sortCompanyName: boolean = false;
    sortRole: boolean = false;
    sortDate: boolean = false;
    sortisRegister: boolean = false;
    ngOnInit(): void {
        this._data
            .subscribe(x => {
                console.log(this._data);
            });
    }

    resetPassword(data: UserlistModel): void {
        this.resetPasswordOutput.emit(data);
    }

    // When click header call function
    sortStatus(event: any, status: boolean): void {
        this.sortUserSurr = false;
        this.sortEmail = false;
        this.sortFullname = false;
        this.sortPhone = false;
        this.sortCompanySurr = false;
        this.sortCompanyName = false;
        this.sortRole = false;
        this.sortDate = false;
        this.sortisRegister = false;
        if (status) { // sort to DESC
            this.sortUserSurr = false;
            this.sortEmail = false;
            this.sortFullname = false;
            this.sortPhone = false;
            this.sortCompanySurr = false;
            this.sortCompanyName = false;
            this.sortRole = false;
            this.sortDate = false;
            this.sortisRegister = false;

            this.sortData.sortCol = event;
            this.sortData.sortType = SortType.DESC;
            this.sortOutput.emit(this.sortData);
        } else {// sort to ASC
            if (event === "userSurrkey") {
                this.sortUserSurr = true;
                this.sortData.sortCol = "userSurrkey";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "userEmail") {
                this.sortEmail = true;
                this.sortData.sortCol = "userEmail";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "fullName") {
                this.sortFullname = true;
                this.sortData.sortCol = "fullName";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "userPhone") {
                this.sortPhone = true;
                this.sortData.sortCol = "userPhone";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companySurrkey") {
                this.sortCompanySurr = true;
                this.sortData.sortCol = "companySurrkey";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "companyName") {
                this.sortCompanyName = true;
                this.sortData.sortCol = "companyName";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "userRole") {
                this.sortRole = true;
                this.sortData.sortCol = "userRole";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "createdate") {
                this.sortDate = true;
                this.sortData.sortCol = "createdate";
                this.sortData.sortType = SortType.ASC;
                this.sortOutput.emit(this.sortData);
            } else if (event === "isRegister") {
              this.sortDate = true;
              this.sortData.sortCol = "isRegister";
              this.sortData.sortType = SortType.ASC;
              this.sortOutput.emit(this.sortData);
            }
        }
    }
}
